type localesKeys__PositionBlock = {
  positionBlock__responsibilitiesLabel: string;
  positionBlock__achievementsLabel: string;
  positionBlock__projectsLabel: string;
}

const ruLocale__PositionBlock: localesKeys__PositionBlock = {
  positionBlock__responsibilitiesLabel: 'Обязанности',
  positionBlock__achievementsLabel: 'Достижения',
  positionBlock__projectsLabel: 'Проекты'
};

const enLocale__PositionBlock: localesKeys__PositionBlock = {
  positionBlock__responsibilitiesLabel: 'Responsibilities',
  positionBlock__achievementsLabel: 'Achievements',
  positionBlock__projectsLabel: 'Projects'
};

export { ruLocale__PositionBlock, enLocale__PositionBlock };
export type { localesKeys__PositionBlock };